import { render, staticRenderFns } from "./RouteNew.vue?vue&type=template&id=a165d07a&"
import script from "./RouteNew.vue?vue&type=script&lang=js&"
export * from "./RouteNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports